// Lib
import React, { useCallback } from 'react';
import Immutable from 'immutable';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { useDispatch } from 'react-redux';
import { moveElementsToTrash } from '../../../../../element/actions/elementShortcutActions';

type MoveToTrashToolProps = {
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
};

const MoveToTrashTool: React.FC<MoveToTrashToolProps> = (props) => {
    const { selectedElements, currentBoardId } = props;

    const dispatch = useDispatch();
    const dispatchMoveElementsToTrash = useCallback(
        () => dispatch(moveElementsToTrash({ elements: selectedElements, currentBoardId })),
        [selectedElements, currentBoardId],
    );

    const onClick = useCallback(() => {
        dispatchMoveElementsToTrash();
    }, [dispatchMoveElementsToTrash]);

    return (
        <div className="MoveToTrashTool">
            <ToolbarTool {...props} name="Remove" onClick={onClick}>
                <Icon name="toolbar-move-to-trash" />
            </ToolbarTool>
        </div>
    );
};

export default MoveToTrashTool;
